import React from "react";

import AudiusSvg from '../global/Svg/Audius'
import SoundcloudSvg from '../global/Svg/Soundcloud'
import MixcloudSvg from '../global/Svg/Mixcloud'
import YoutubeSvg from '../global/Svg/Youtube'
import SpotifySvg from '../global/Svg/Spotify'
import AppleMusicSvg from '../global/Svg/AppleMusic'
import AmazonMusicSvg from '../global/Svg/AmazonMusic'
import DeezerSvg from '../global/Svg/Deezer'
import QobuzSvg from '../global/Svg/Qobuz'
import BandcampSvg from '../global/Svg/Bandcamp'

const Streaming = () => {
    return (
        <>
            <a aria-label="Profil Spotify" href='https://open.spotify.com/intl-fr/artist/40Gb8y4Us0UVQS56f4oYvI' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <SpotifySvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Apple Music" href='https://music.apple.com/us/artist/dj-n47/1465969215' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <AppleMusicSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Amazon Music" href='https://www.amazon.com/music/player/artists/B07ZPD61M2/dj-n47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <AmazonMusicSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Youtube Music" href='https://music.youtube.com/channel/UCwJ9RZIF9xN2DOEmXU_5sig' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <YoutubeSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Deezer" href='https://www.deezer.com/fr/artist/66552622' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <DeezerSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Soundcloud" href='https://soundcloud.com/n47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <SoundcloudSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Bandcamp" href='https://djn47.bandcamp.com/' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <BandcampSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Qobuz" href='https://www.qobuz.com/fr-fr/interpreter/dj-n47/11215338' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <QobuzSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Audius" href='https://audius.co/n47' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <AudiusSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
            <a aria-label="Profil Mixcloud" href='https://www.mixcloud.com/N47/' target='_blank' rel="noreferrer" className='inline-block m-2'>
                <MixcloudSvg className={`fill-red-600 hover:fill-red-300`} />
            </a>
        </>
    )
}

export default Streaming